import { useNavigation, useRoute } from '@react-navigation/core'
import { useCallback, useEffect, useState } from 'react'
import { AmountInput } from '../../comps/AmountInput'
import { TransactionQueryComp } from '../../comps/TransactionQueryComp'
import { Screens } from '../../nav/Screens'
import { JIO_PAYMENT_BANK_BIN } from '../../util/utill'

export const CashWOrDScreen = () => {
  const navigation = useNavigation<any>()
  const route: any = useRoute()
  const [amount, setAmount] = useState(route?.params?.amount ?? null)
  const [bankId, setBankId] = useState(null)
  const [error, setError] = useState('')

  const isDisabled = () => (!amount || amount < 10 || error ? true : false)
  const staticData = CONFIGURATION[route.params.type]

  useEffect(() => {
    navigation.setOptions({ headerTitle: staticData.headerTitle })
  }, [navigation, staticData.headerTitle])

  const setErrorForIncorrectAmount = useCallback(
    (selectedBankId: any, selectedAmount: any) => {
      if (route.params.type === 'cash_withdrawal' && selectedAmount < 100) {
        setError('** Minimum Amount should be 100 !')
      } else if (route.params.type === 'cash_withdrawal' && selectedAmount > 100 && selectedAmount % 50 !== 0) {
        setError('** Amount should be multiple of 50 !')
      } else {
        setError('')
      }
    },
    [route.params.type],
  )
  const onAmountChange = useCallback(
    (text: any) => {
      setAmount(text)
      setErrorForIncorrectAmount(bankId, text)
    },
    [bankId, setErrorForIncorrectAmount],
  )
  const onBankNameChanged = (id: string) => {
    setBankId(id)
    setErrorForIncorrectAmount(id, amount)
  }

  return (
    <>
      <AmountInput
        amount={amount}
        onAmountChange={onAmountChange}
        title={staticData.title}
        error={error}
        transactionType={
          route.params.type === 'cash_deposit' && bankId === JIO_PAYMENT_BANK_BIN
            ? 'jpb_cash_deposit'
            : route.params.type
        }
      />
      <TransactionQueryComp
        onSubmit={({ bankName, aadhaarNo, mobileNo, vid }: any) =>
          navigation.navigate(
            /* route.params.type === 'cash_withdrawal' && bankId !== '607884'
              ? (Screens.AGENT_AUTH_SCREEN as never)
              : (Screens.REVIEW_CASH_WITHDRAWAL as never),*/
            Screens.REVIEW_CASH_WITHDRAWAL as never,
            {
              ...route.params,
              bankName,
              aadhaarNo,
              mobileNo,
              amount: +amount + '',
              vid,
              activityType: route.params.type === 'cash_withdrawal' ? 'CUSTOMER_CW' : 'CUSTOMER_CD',
            } as never,
          )
        }
        params={{ ...(route?.params ?? {}) }}
        isLoading={false}
        buttonText="Proceed"
        isDisabled={isDisabled()}
        screenName={Screens.CASH_W_OR_D_Screen}
        showFingerPrintModel={false}
        activityType={route.params.type === 'cash_withdrawal' ? 'CUSTOMER_CW' : 'CUSTOMER_CD'}
        onBankNameChanged={onBankNameChanged}
      />
    </>
  )
}

const CONFIGURATION: any = {
  cash_withdrawal: {
    headerTitle: 'Cash Withdrawal',
    title: 'Amount to withdraw',
  },
  cash_deposit: {
    headerTitle: 'Cash Deposit',
    title: 'Amount to Deposit',
  },
}
